/**
 * Parses object to int safely, thus returning 'null' if not possible
 * @param {integer} parsedInt
 */

export function parseIntSafely(s) {
  return (s && s !== "") ? parseInt(s) : null;
}